import React, { useEffect, useState } from "react";
import {
  Dialog,
  FormControlLabel,
  Radio,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "../modals/modal.css";
import CustomButton from "../../reusableComponents/CustomButton";
import { isEmpty } from "../utils/utils";

const theme = createTheme({
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "rgba(36, 183, 170, 1)",
          height: "16px",
          width: "16px",
          marginRight: "8px",
          marginLeft: "10px",
          "&.Mui-checked": {
            color: "rgba(36, 183, 170, 1)",
            height: "16px",
            width: "16px",
            marginRight: "8px",
          },
        },
      },
    },
  },
});

export default function CustomDateModal({
  openModal,
  onClose,
  handleṢingleStartDate,
  singleStartDateValue,
  handleStartDate,
  handleEndDate,
  previousDropdownContent,
  setDropdownContent,
  handleDropdownChange,
  radioButton,
  setRadioButton,
  startDateValue,
  endDateValue
}) {
  const today = new Date();
  const minDate = new Date(2022, 0, 1);
  const [selectedDate, setSelectedDate] = useState(null);
  const [singleDateError, setSingleDateError] = useState(false);
  const [startDateRangeError, setStartDateRangeError] = useState(false);
  const [endDateRangeError, setEndDateRangeError] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateRangeValidation, setDateRangeValidation] = useState(false);
  const [isApplyButtonDisabled, setIsApplyButtonDisabled] = useState(true);


  useEffect(() => {
    let radioValue = localStorage.getItem("dateRadio");
    if (radioValue) {
      setRadioButton(radioValue);
    } else {
      setRadioButton('singleDate');
    }
    if (radioValue === 'singleDate') {
      handleStartDate(null);
      setStartDate(null);
      handleEndDate(null);
      setEndDate(null);
      localStorage.removeItem("selectStartDate");
      localStorage.removeItem("selectEndDate");
    } else if (radioValue === 'dateRange') {
      handleṢingleStartDate(null);
      setSelectedDate(null);
      localStorage.removeItem("selectSingleDate");
    }
  }, [])

  useEffect(() => {
    let dateString = localStorage.getItem("selectSingleDate");
    const dateObject = dateString ? new Date(dateString) : null;
    if (singleStartDateValue) setSelectedDate(singleStartDateValue)
    else if (!isEmpty(dateObject)) {
      handleṢingleStartDate(dateObject);
      setSelectedDate(dateObject)
    }
  }, [singleStartDateValue]);
  useEffect(() => {
    let dateString = localStorage.getItem("selectStartDate");
    const dateObject = dateString ? new Date(dateString) : null;
    if (startDateValue) setStartDate(startDateValue)
    else if (!isEmpty(dateObject)) {
      handleStartDate(dateObject);
      setStartDate(dateObject);
    }
  }, [startDateValue]);

  useEffect(() => {
    let dateString = localStorage.getItem("selectEndDate");
    const dateObject = dateString ? new Date(dateString) : null;
    if (endDateValue) setEndDate(endDateValue)
    else if (!isEmpty(dateObject)) {
      handleEndDate(dateObject);
      setEndDate(dateObject);
    }
  }, [endDateValue]);

  const handleRadioChange = (e) => {
    setSelectedDate(null);
    setStartDate(null);
    setEndDate(null);
    setRadioButton(e.target.value);
    localStorage.setItem("dateRadio", e.target.value);
    localStorage.removeItem("selectSingleDate");
    localStorage.removeItem("selectStartDate");
    localStorage.removeItem("selectEndDate");
  };

  const handleDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      if (date < minDate || date > today) {
        setSingleDateError(true);
      } else {
        localStorage.setItem("selectSingleDate", date.toISOString());
        setSelectedDate(date);
        setSingleDateError(false);
      }
    } else {
      setSingleDateError(true);
    }
  };
  const handleCloseModal = () => {
    setDropdownContent(previousDropdownContent || 'today');
    handleDropdownChange(previousDropdownContent || 'today');
    onClose();
    setStartDate(null);
    setEndDate(null);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      handleCloseModal();
    }
  };
  const handleDateRangeError = (e, type) => {
    if (type == "start") {
      if (e == "maxDate" || e == "minDate") {
        setDateRangeValidation(true);
      } else {
        setDateRangeValidation(false);
      }
    } else if (type == "end") {
      if (e == "maxDate" || e == "minDate") {
        setDateRangeValidation(true);
      } else {
        setDateRangeValidation(false);
      }
    } else {
    }
  };
  const validateDateRange = (startDate, endDate) => {
    const isValidDateRange =
      radioButton === "dateRange" &&
      startDate !== null &&
      endDate !== null &&
      !startDateRangeError &&
      !endDateRangeError;
    const isEndBeforeStart = startDate && endDate && endDate < startDate;
    const isEndInFuture = endDate && endDate > today;
    const maxDateDiffExceeded =
      startDate &&
      endDate &&
      (endDate - startDate) / (1000 * 60 * 60 * 24) > 62;

    setIsApplyButtonDisabled(
      !isValidDateRange ||
      isEndBeforeStart ||
      isEndInFuture ||
      maxDateDiffExceeded
    );
  };
  const calculateStartDateConstraints = (endDate) => {
    if (!endDate) return { minDate: null, maxDate: new Date() };

    const minDate = new Date(endDate.getTime() - 62 * 24 * 60 * 60 * 1000);
    const maxDate = endDate;

    return { minDate, maxDate };
  };

  const handleStartDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setStartDate(date);
      localStorage.setItem("selectStartDate", date.toISOString());
      setStartDateRangeError(false);
    } else {
      setStartDateRangeError(true);
    }
    validateDateRange(date, endDate);
  };

  const handleEndDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setEndDate(date);
      localStorage.setItem("selectEndDate", date.toISOString());
      setEndDateRangeError(false);
    } else {
      setEndDateRangeError(true);
    }
    validateDateRange(startDate, date);
  };

  useEffect(() => {
    if (
      radioButton === "singleDate" &&
      selectedDate !== null &&
      !singleDateError
    ) {
      setIsApplyButtonDisabled(false);
    } else {
      setIsApplyButtonDisabled(true);
    }
  }, [selectedDate, singleDateError, radioButton]);

  useEffect(() => {
    validateDateRange(startDate, endDate);
  }, [
    startDate,
    endDate,
    radioButton,
    startDateRangeError,
    endDateRangeError,
  ]);

  const submitDateModal = () => {
    handleṢingleStartDate(selectedDate);
    handleStartDate(startDate);
    handleEndDate(endDate);
    onClose();
  };

  const getMaxEndDate = (startDate) => {
    if (!startDate) return today; // If no start date, max date is today
    const maxDate = new Date(startDate.getTime() + 62 * 24 * 60 * 60 * 1000);
    return maxDate > today ? today : maxDate; // Ensure max date does not exceed today's date
  };

  const { minDate: minStartDate, maxDate: maxStartDate } =
    calculateStartDateConstraints(endDate);

  return (
    <>
      <Dialog
        className="orderManagementModal"
        open={openModal}
        onKeyDown={handleKeyDown}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "6px",
            padding: "24px 24px 0px 24px",
          }}
        >
          <Typography className="SemiboldTwenty font-black-highest">
            Custom Range
          </Typography>
          <img
            src="/assets/ic_twotone-close.svg"
            alt="cross"
            onClick={() => handleCloseModal()}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Typography
          className="labelRegular font-black-high"
          style={{ padding: "4px 24px" }}
        >
          Date range allows a maximum range of 62 days
        </Typography>
        <div
          className="displayDirectionRow"
          style={{
            display: "flex",
            marginTop: "20px",
            height: "250px",
            padding: "0px 24px",
          }}
        >
          <ThemeProvider theme={theme}>
            <div>
              <div className="">
                <FormControlLabel
                  className={`radioLabels ${radioButton === "singleDate" && "selectedRadioColor"
                    }`}
                  value="singleDate"
                  control={<Radio color="default" />}
                  label="Single Date"
                  checked={radioButton === "singleDate"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>
              <div>
                <FormControlLabel
                  className={`radioLabels ${radioButton === "dateRange" && "selectedRadioColor"
                    }`}
                  value="dateRange"
                  control={<Radio color="default" />}
                  label="Date Range"
                  checked={radioButton === "dateRange"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>
            </div>
          </ThemeProvider>
          <div className="dateRange">
            {radioButton === "singleDate" && (
              <div style={{ display: "flex" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="dd/MM/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    maxDate={today}
                    minDate={minDate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        style={{
                          borderColor: singleDateError ? "red" : "blue",
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            )}
            {radioButton === "dateRange" ? (
              <>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <div style={{ display: "flex" }}>
                    <DatePicker
                      format="dd/MM/yyyy"
                      minDate={minStartDate}
                      maxDate={maxStartDate}
                      value={startDate}
                      onError={(e) => handleDateRangeError(e, "start")}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          style={{
                            borderColor: startDateRangeError ? "red" : "blue",
                          }}
                        />
                      )}
                    />

                    <DatePicker
                      format="dd/MM/yyyy"
                      minDate={startDate || null}
                      maxDate={getMaxEndDate(startDate)}
                      value={endDate}
                      onError={(e) => handleDateRangeError(e, "end")}
                      disableDates={(date) => startDate && date < startDate}
                      onChange={handleEndDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          style={{
                            borderColor: endDateRangeError ? "red" : "blue",
                          }}
                        />
                      )}
                    />
                  </div>
                </LocalizationProvider>
              </>
            ) : null}
            {dateRangeValidation && (
              <Typography
                style={{
                  color: "var(--Comms-Negative, #b9232f)",
                  fontSize: "10px",
                  fontWeight: 400,
                }}
              >
                Please select correct date
              </Typography>
            )}
          </div>
        </div>
        <div
          style={{
            paddingBottom: "24px",
            paddingTop: "24px",
            display: "flex",
            justifyContent: "end",
            paddingRight: "24px",
            boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          }}
        >
          <div style={{ marginLeft: "8px" }}>
            <CustomButton
              variant={"contained"}
              size={"sm"}
              type={"secondary"}
              text={"Apply"}
              disabled={isApplyButtonDisabled}
              onClick={submitDateModal}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}
